//External
import React from "react";
import Head from "next/head";
import { FACEBOOK_PIXEL_ID, GOOGLE_TAG_MANAGER_ID } from "utils";
import ReactHtmlParser from "react-html-parser";
import { useRouter } from "next/router";
import serializeJsonLd from "utils/serializeJsonLd";
// import { BASE_URL, APP_ENVIRONMENT, CDN_PATH } from "config";
import { BASE_URL, APP_ENVIRONMENT } from "config";

/*******************
@Purpose : Used for meta tags
@Parameter : {metaData}
@Author : INIC
******************/
function MetaTags({
  metaData,
  brandBannerInfo,
  categoryBannerInfo,
  vehicalDetailData,
  currentPage,
  cityNameForMeta,
  homePageData,
  addressInfo,
}) {
  const router = useRouter();
  const asPath = router.asPath;

  /*******************
  @purpose : Make  title , meta title
  @Parameter : {str,h1Text,h2Text}
  @Author : INIC
  ******************/
  const makeTitle = (str, h1Text, h2Text) => {
    let title = "";
    if (str) {
      title = str.trim();
    } else {
      title = h1Text + " - " + h2Text;
    }
    return title;
  };

  /*******************
  @purpose : Make  title , meta title for vehicle
  @Parameter : {str,h1Text,h2Text}
  @Author : INIC
  ******************/
  const makeTitleVehicle = (str, h1Text) => {
    let title = "";
    if (str) {
      title = str.trim();
    } else {
      title = h1Text;
    }
    return title;
  };

  /*******************
  @purpose : Make  meta keywords
  @Parameter : {str,h1Text,h2Text}
  @Author : INIC
  ******************/
  const makeKeywords = (str, h1Text, h2Text) => {
    let keywords = "";
    if (str) {
      keywords = str.trim();
    } else {
      keywords = h1Text + " , " + h2Text;
    }
    return keywords;
  };

  /*******************
  @purpose : Make canonical url
  @Parameter : {str}
  @Author : INIC
  ******************/
  const makeCanonical = (str) => {
    if (asPath != "/") {
      return BASE_URL + asPath;
    } else {
      return BASE_URL;
    }
  };

  /*******************
  @purpose : Make description For vehicle 
  @Parameter : {str}
  @Author : INIC
  ******************/
  const makeDescriptionForVehicle = (str, nameWithBrand, Name) => {
    let des = "";
    if (str) {
      des = str;
    } else {
      des =
        "Rent a " +
        nameWithBrand +
        " from Falcon Car Rental in " +
        cityNameForMeta +
        ". Click here for more info or to reserve the " +
        Name +
        " online!";
    }
    return des;
  };

  /****************
  @purpose : SEO Intigration
  @Author : INIC
  ******************/
  let title = metaData?.title?.trim() ?? "";
  let keywords = metaData?.keywords?.trim() ?? "";
  let description = metaData?.description?.trim() ?? "";
  let canonical = "";

  // let ogImgUrl = CDN_PATH + "/preview.png";

  let ogImgUrl = addressInfo?.company_logo;

  if (metaData?.vehicle_high_resolution_image) {
    ogImgUrl = metaData?.vehicle_high_resolution_image;
  }

  //ogImgUrl = ogImgUrl + '?ts=' + moment();

  let siteName = "Falcon Car Rental";

  // home and dynamic page
  if (currentPage == "home" || currentPage == "dynamic") {
    title = makeTitle(
      metaData?.title,
      homePageData?.title,
      homePageData?.bottom_title
    );
    keywords = makeKeywords(
      metaData?.keywords,
      homePageData?.title,
      homePageData?.bottom_title
    );
  }

  // brand
  if (currentPage == "brand") {
    title = makeTitle(
      metaData?.title,
      brandBannerInfo?.title,
      brandBannerInfo?.bottom_title
    );
    keywords = makeKeywords(
      metaData?.keywords,
      brandBannerInfo?.title,
      brandBannerInfo?.bottom_title
    );
  }

  // category
  if (currentPage == "category") {
    title = makeTitle(
      metaData?.title,
      categoryBannerInfo?.title,
      categoryBannerInfo?.bottom_title
    );
    keywords = makeKeywords(
      metaData?.keywords,
      categoryBannerInfo?.title,
      categoryBannerInfo?.bottom_title
    );
  }

  // vehicle
  if (currentPage == "vehicle") {
    const nameWithBrand = vehicalDetailData.vehicle.name_with_brand;
    const h1TextTitle = nameWithBrand + " Rental in " + cityNameForMeta;
    const h1TextKeywords = nameWithBrand + " Rental " + cityNameForMeta;
    const h2TextKeywords = "Rent a " + nameWithBrand + " " + cityNameForMeta;

    title = makeTitleVehicle(metaData?.title, h1TextTitle);
    keywords = makeKeywords(metaData?.keywords, h1TextKeywords, h2TextKeywords);
    description = makeDescriptionForVehicle(
      metaData?.description,
      vehicalDetailData.vehicle.name_with_brand,
      vehicalDetailData.vehicle.name
    );
  }
  canonical = makeCanonical();
  const pageSchema = serializeJsonLd(metaData?.page_schema);

  return (
    <div>
      <Head>
        {APP_ENVIRONMENT === "production" && (
          <>
            {/* Google Tag Manager */}
            <script
              defer
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');`,
              }}
            ></script>

            {/* facebook pixel code start here */}
            <script
              defer
              dangerouslySetInnerHTML={{
                __html: `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${FACEBOOK_PIXEL_ID}');
      fbq('track', 'PageView');`,
              }}
            />
            <noscript
              dangerouslySetInnerHTML={{
                __html: `<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID}&ev=PageView&noscript=1" />`,
              }}
            />
            {/* facebook pixel code end here */}
          </>
        )}
        {APP_ENVIRONMENT === "local" && (
          <meta
            name="google-site-verification"
            content="zRqXbP5be628KOFA7GL11qBqxkQ_kuNMnmFZLmmmKcE"
          />
        )}
        {APP_ENVIRONMENT === "staging" && (
          <meta
            name="google-site-verification"
            content="zRqXbP5be628KOFA7GL11qBqxkQ_kuNMnmFZLmmmKcE"
          />
        )}
        {APP_ENVIRONMENT === "development" && (
          <meta
            name="google-site-verification"
            content="_WSWuV2uuVxIg97OXb0xHhrvwW693BFaxwOQd3ABIO4"
          />
        )}
        {APP_ENVIRONMENT === "production" && (
          <meta
            name="google-site-verification"
            content="f6MOukTSputsWgop3GEyuuP9a7d_oigRWd_6HBxBlbI"
          />
        )}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, viewport-fit=cover"
        />
        <link rel="profile" href="https://gmpg.org/xfn/11" />
        {APP_ENVIRONMENT === "production" ? (
          <>
            <meta name="robots" content="index,follow" />
            <meta name="googlebot" content="index,follow" />
          </>
        ) : (
          <>
            <meta name="robots" content="none" />
            <meta name="googlebot" content="none" />
          </>
        )}
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="keywords" content={keywords} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:image" content={ogImgUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content={ogImgUrl} />

        {ReactHtmlParser(
          `<meta name="description" content="${description}"  />`
        )}
        {/*<link rel="canonical" href={canonical} />*/}
        {pageSchema && (
          <script
            defer
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: pageSchema,
            }}
          ></script>
        )}
      </Head>
    </div>
  );
}

export default MetaTags;
